import { app } from '../../../../../app';
import { Controller } from './help.controller';

app.component('companyManageApplicationIntegrationDevelopersHelp', {
    bindings: {application: '<'},
    controller: Controller,
    templateUrl: require('./help.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/help/help.component.js